
import { Card, CardContent } from "@/components/ui/card";
import { Package, AlertTriangle } from "lucide-react";

interface Product {
  id: string;
  barcode: string;
  name: string;
  boxes: number;
  unitsPerBox: number;
  photos: string[];
  hasCredit: boolean;
}

interface ProductSearchDropdownProps {
  products: Product[];
  onSelect: (product: Product) => void;
  onClose: () => void;
}

export const ProductSearchDropdown = ({ products, onSelect, onClose }: ProductSearchDropdownProps) => {
  if (products.length === 0) {
    return (
      <Card className="absolute top-full left-0 right-0 z-50 mt-1 border shadow-lg bg-white">
        <CardContent className="p-3">
          <div className="flex items-center gap-2 text-gray-500">
            <Package className="w-4 h-4" />
            <span className="text-sm">No products found</span>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="absolute top-full left-0 right-0 z-50 mt-1 border shadow-lg bg-white max-h-60 overflow-y-auto">
      <CardContent className="p-0">
        {products.map((product) => (
          <div
            key={product.id}
            className="p-3 hover:bg-gray-50 cursor-pointer border-b last:border-b-0 transition-colors"
            onClick={() => onSelect(product)}
          >
            <div className="flex items-center gap-3">
              {product.photos.length > 0 && (
                <img
                  src={product.photos[0]}
                  alt="Product"
                  className="w-10 h-10 object-cover rounded"
                />
              )}
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h4 className="font-medium text-sm">{product.name}</h4>
                  {product.hasCredit && (
                    <AlertTriangle className="w-3 h-3 text-orange-500" />
                  )}
                </div>
                <p className="text-xs text-gray-600">Barcode: {product.barcode}</p>
                <div className="flex gap-4 text-xs text-gray-500 mt-1">
                  <span>Boxes: {product.boxes}</span>
                  <span>Units/Box: {product.unitsPerBox}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
